import React from 'react';

const FilterIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.6693 2H1.33594L6.66927 8.30667V12.6667L9.33594 14V8.30667L14.6693 2Z'
        stroke='#5D665F'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default FilterIcon;
